import styled from "styled-components"
import Background from '../assets/Helixor/helixor-background.jpg'

export const DoctorDirectoryContainer = styled.div`
    background-color: black;
    width: 100%;
   
    background-image: url(${Background});
    background-size: cover;
    background-position: center;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`

export const HeaderDirectory = styled.div`
    padding: 4em;

    img{
        width: 150px;
    }

    @media (max-width: 768px) {
      padding: 2.5em;

      img{
        width: 100px;
    }
    }
`
export const ContentContainer = styled.div`
  display: flex;
`

export const Container = styled.div`
  width: 20%;
  display: flex;
  width: auto;
  flex-direction: column;
  padding: 40px;
  padding-left: 5em;

  @media (max-width: 768px) {
    padding-left: 2em;
  }
`;

export const Logo = styled.h1`
  display: flex;
  align-items: center;
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 1em;

  img{
    width: 250px;
  }
`;

export const Subtitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #222;
  letter-spacing: 2px;
  margin-bottom: -20px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const Country = styled.h2`
  font-size: 90px;
  font-weight: bold;
  color: #e5721b;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 60px;
  }
`;

export const Button = styled.button`
  background: #e5721b;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  transition: 0.3s;
  width: 200px;

  &:hover {
    background: #c55a14;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    width: 150px;
  }
`;